enum IncomeVerificationIncomeSourceEmploymentDocumentEnum {
    EmploymentContract = 'employmentContract',
    EmployerStatement = 'employerStatement',
    PayslipOne = 'payslipOne',
    PayslipTwo = 'payslipTwo',
    PayslipThree = 'payslipThree',
}

export default IncomeVerificationIncomeSourceEmploymentDocumentEnum;
